export default "__VITE_ASSET__Cq2cxotP__"